import React from "react";
import styled from "styled-components";
import { Button, Grid } from "@mui/material";
import { AddLink } from "@mui/icons-material";
import Icon from "../../components/icon";
import Flex from "../../components/flex";

const ButtonWithBorder = styled(Button)`
    ${({ theme, checked }) =>
        checked
            ? `border: 4px solid ${theme.palette.primary.main}`
            : `border: 4px solid transparent`};
`;

const Integrated = styled(Flex).attrs(() => ({
    justifyContent: "center",
}))`
    position: absolute;
    top: -4px;
    right: -4px;
    height: 40px;
    width: 40px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-bottom-left-radius: 8px;
    border-top-right-radius: 2px;
`;

const FutureIntegration = styled(Flex).attrs(() => ({
    justifyContent: "center",
}))`
    position: absolute;
    top: -4px;
    height: 40px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    text-transform: capitalize;
    padding-left: ${({ theme }) => theme.spacing(3)};
    padding-right: ${({ theme }) => theme.spacing(3)};
    color: ${({ theme }) => theme.palette.primary.main};
`;

const WizardIntegrationButton = ({ svg, action, checked, connected, future, maintenance }) => (
    <Grid container item spacing={2}>
        <Grid item>
            <ButtonWithBorder
                checked={checked}
                variant="contained"
                onClick={action}
                style={{
                    width: "75px",
                    height: "75px",
                }}
                color="secondary"
                disabled={future || maintenance}
            >
                {connected && (
                    <Integrated>
                        <AddLink color="primary" />
                    </Integrated>
                )}
                {maintenance && <FutureIntegration>under maintenance</FutureIntegration>}
                <Icon svg={svg} width="100px" height="127" />
            </ButtonWithBorder>
        </Grid>
    </Grid>
);

export default WizardIntegrationButton;
